import { useEffect } from 'react'

import { Drawer, Typography } from '@evocolabs/orkaui'
import { Box } from '@mui/material'
import style from '@/pages/scss/OrkaTwo.module.scss'
import imgs from '../data/imgs'

import { disableBack, recoverDisableBack } from '@/src/utils/historyImprove'

const { whatBoxImgs } = imgs
const data = {
  title: `What's in the Box`,
  imgs: [
    { alt: '① Charging Case' },
    { alt: '② Hearing Aids' },
    { alt: '③ Domes' },
    { alt: '④ USB-C Charge Cable' },
    { alt: '⑤ User Manual' },
    { alt: '⑥ Wax Guard & Brush' },
    { alt: '⑦ Teck Book' },
    { alt: '⑧ Wire Sizing Tool' }
  ],
  img: whatBoxImgs[0]
}
const WhatBox = function ({ open, onClose } = props) {
  useEffect(() => {
    if (open) {
      disableBack(() => {
        recoverDisableBack()
        onClose()
      })
    }
  }, [open])
  return (
    <>
      <Drawer
        open={open}
        onClose={onClose}
        disableMobSizeAdjustment={true}
        sx={{
          top: { xs: '48px', dl: '0' },
          '>.MuiPaper-root': { top: { xs: '48px', dl: '0' } },
          ' .orkaui-drawer-container': {
            paddingBottom: '32px',
            display: 'flex',
            height: '100%'
          }
        }}
      >
        <Box display="flex" flexDirection="column" height="100%">
          <Typography variant="h3">{data.title}</Typography>
          <Box className={style['what-box-img-box']}>
            <img
              src={data.img}
              alt="what's in the Box"
              style={{ width: '100%' }}
            />
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                mt: '16px',
                width: '100%',
                'div:nth-of-type(n+1)': { mt: '8px' }
              }}
            >
              {data.imgs.map((d) => (
                <Box
                  sx={{ flexBasis: 'calc(50% - 16px)', order: d.order }}
                  key={d.alt}
                >
                  <Typography variant="body2">{d.alt}</Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Drawer>
    </>
  )
}

export default WhatBox
